
export const contactObj = {
  FaceBook: "https://www.facebook.com/",

  instagram:"https://www.instagram.com/",
	Youtube: "https://www.youtube.com/",
	Pinterest: "https://www.pinterest.com/",
	Linkedin: "https://www.linkedin.com/",

	Twitter: "https://twitter.com/",
	Tiktok: "https://www.tiktok.com/",
  Whatsapp:"https://wa.me/8618988726469",

};


export const contactInfo={
	email:"153886007@qq.com",

	phone:"18988726469",
  Tel:"0769-81506106",
	whatsapp:"",
	wechat:"",
	address:"广东省东莞市厚街镇白濠第三工业园",
	name: "东莞市恒配达自动化配件有限公司",

}

